import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {IStore} from "./store/reducers";
import actionTypes from "./store/actionTypes";
import {IConnections, IDataPartner, INotificacion, IPartnersSections} from "./types";
import navBarHorizontal from "./Partners/navigation/NavBarHorizontal";
import navBarVertical from "./Partners/navigation/NavBarVertical";
import Clientes from "./Partners/sections/clientes/Clientes";
import Dashboard from "./Partners/sections/dashboard/Dashboard";
import Promociones from "./Partners/sections/promociones/Promociones";
import Opciones from "./Partners/sections/opciones/Opciones";
import Chat from "./Partners/sections/chat/Chat";
import Faq from "./Partners/sections/faq/Faq";
import NavBarHorizontal from "./Partners/navigation/NavBarHorizontal";
import NavBarVertical from "./Partners/navigation/NavBarVertical";
import axios from "axios";
import config from "./config.json";
import {partnerService} from "./services/PartnerService";
import CustomSnackbar from "./CropSense/navigation/CustomSnackbar";
import CrearPromocion from "./dialogs/CrearPromocion";


interface IProps {
    section: IPartnersSections
    notification: INotificacion | null
    cropsense: boolean
    setDataPartner(data: IDataPartner): void
    setConnections(data: IConnections): void
    setLastConnections(data: Record<string, string>): void
    closeNotification(): void
    notify(notification: INotificacion): void
}

interface Istate {
}


class PartnersApp extends React.Component<IProps, Istate> {

    componentDidMount() {
        axios.get(
            config.url+'/partner/connection',
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .catch(() => {
                partnerService.logout()
            })
        axios.get(
            config.url+'/init/partner',
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then((res) => {
                this.props.setDataPartner(res.data)
            })
            .catch(() => {
                this.props.notify({message: "Error solicitando datos", variant: 'error'})
            })

        axios.get(
            config.url+'/connections',
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then((res) => {
                this.props.setConnections(res.data)
            })
            .catch(() => {
                this.props.notify({message: "Error solicitando datos", variant: 'error'})
            })

        axios.get(
            config.url+'/last/connections',
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then((res) => {
                this.props.setLastConnections(res.data)
            })
            .catch(() => {
                this.props.notify({message: "Error solicitando datos", variant: 'error'})
            })

    }

    state:Istate = {
    }


    chooseSection = (section: IPartnersSections): ReactNode => {
        switch (section) {
            case 'dashboard':
                return <Dashboard/>
            case 'clientes':
                return <Clientes/>
            case 'promociones':
                return <Promociones/>
            case 'opciones':
                return <Opciones/>
            case 'chat':
                return <Chat/>
            case 'faq':
                return <Faq/>
            default:
                return <div style={{marginTop: 20}}>{`Sección ${section} desconocida`}</div>
        }
    };


    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100vw',
                    height: '100vh'
                }}
            >
                <CrearPromocion/>
                <CustomSnackbar
                    open={this.props.notification != null}
                    variant={(this.props.notification != null) ? this.props.notification.variant: "info"}
                    message={this.props.notification && this.props.notification.message}
                    autoHideDuration={5000}
                    onClose={this.props.closeNotification}
                />

                {!this.props.cropsense &&
                    <div style={{width: 201, height: "100%"}}>
                        <NavBarVertical/>
                    </div>
                }

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: this.props.cropsense? '100%' : 'calc(100% - 201px)',
                        height: "100%"
                    }}
                >
                    <div style={{width: "100%", height: 72}}>
                        <NavBarHorizontal cropsense={this.props.cropsense}/>
                    </div>

                    <div
                        style={{width: "100%", height: 'calc(100% - 72px)'}}
                    >
                        {this.chooseSection(this.props.section)}
                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    section: state.navegacionPartners.section,
    notification: state.navegacionPartners.notification,
    cropsense: state.navegacionPartners.cropsense
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setDataPartner: (data: IDataPartner) => dispatch({type: "set-data-partner", data}),
    setConnections: (data: IConnections) => dispatch({type: "set-connections", data}),
    setLastConnections: (data: Record<string, string>) => dispatch({type: "set-last-connections", data}),
    closeNotification: () => dispatch({type: "notify-partners", notification: null}),
    notify: (notification: INotificacion) => dispatch({type: 'notify-partners', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnersApp);
